"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertVisualizationClass = void 0;
var tslib_1 = require("tslib");
exports.convertVisualizationClass = function (visClass) {
    var _a = visClass.visualizationClass, content = _a.content, meta = _a.meta;
    return {
        visualizationClass: tslib_1.__assign(tslib_1.__assign({}, content), { identifier: meta.identifier, title: meta.title, uri: meta.uri }),
    };
};
//# sourceMappingURL=VisualizationClassConverter.js.map